"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const webjs_sdk_1 = require("@aria/webjs-sdk");
const bew_localization_1 = require("@skype/bew-localization");
const config_1 = require("config");
const React = require("react");
const AriaContext_1 = require("src/ts/contexts/AriaContext");
const EcsContext_1 = require("src/ts/contexts/EcsContext");
const EcsHelper_1 = require("src/ts/helpers/EcsHelper");
const SharedTypes_1 = require("src/ts/models/SharedTypes");
const HuddleApiClient_1 = require("src/ts/rest/HuddleApiClient");
const MeetingsApiClient_1 = require("src/ts/rest/MeetingsApiClient");
const MeetingContext_1 = require("../../contexts/meetings/MeetingContext");
const CookieHelper_1 = require("../../helpers/CookieHelper");
const EnvironmentHelper_1 = require("../../helpers/EnvironmentHelper");
const ErrorHelper_1 = require("../../helpers/ErrorHelper");
const LoggerHelper_1 = require("../../helpers/LoggerHelper");
const ARootView_1 = require("../common/ARootView");
const LoadingView_1 = require("../common/LoadingView");
const StackNavigationView_1 = require("../common/StackNavigationView");
const JoinView_1 = require("./JoinView");
const Launcher_1 = require("./Launcher");
const UnifiedView_1 = require("./UnifiedView");
class RootView extends ARootView_1.ARootView {
    constructor(props) {
        super(props);
        this.getLoginView = () => {
            const useUnifiedView = this.determineIsItUnifiedView(this.state.ecsContext.settings.useUnifiedView);
            if (useUnifiedView) {
                return React.createElement(UnifiedView_1.UnifiedView, { onLaunchClick: this._onLaunchClick });
            }
            else {
                return React.createElement(JoinView_1.JoinView, { onLaunchClick: this._onLaunchClick, useNewLogo: useUnifiedView });
            }
        };
        this.loadConversation = () => {
            const shortId = this._getShortIdFromUrl();
            if (!shortId) {
                throw ErrorHelper_1.displayableErrors.ShortIdFromUrl;
            }
            if (this.props.userContext) {
                EcsHelper_1.ecsHelper.loadConfig(this.props.userContext.skypetoken, this.props.userContext.expiration, (settings) => {
                    const wasPreLoggedin = Boolean(this.props && this.props.userContext && this.props.userContext.skypetoken);
                    const useUnifiedView = this.determineIsItUnifiedView(settings.useUnifiedView);
                    LoggerHelper_1.logger.sessionStarted({ useUnifiedView, wasPreLoggedin });
                    this.setState({
                        loadingEcs: false,
                        ecsContext: {
                            settings,
                        },
                    }, () => {
                        if (settings.useMeetingsApi) {
                            this.loadConversationFromMeetingsApi(shortId);
                        }
                        else {
                            this.loadConversationFromHuddleApi(shortId);
                        }
                    });
                }, {
                    useMeetingsApi: false,
                    useUnifiedView: false,
                });
            }
        };
        this._onLaunchClick = () => {
            LoggerHelper_1.logger.sessionFinished({ completionType: 'LaunchSkypeNowButton' }, webjs_sdk_1.AWTEventPriority.Immediate_sync);
            this.setState((oldState) => {
                return { launcherKey: oldState.launcherKey + 1 };
            });
        };
        this.state = {
            launcherKey: EnvironmentHelper_1.deviceType === EnvironmentHelper_1.DeviceTypes.Desktop ? 1 : 0,
            loadingEcs: true,
            loadingConversation: true,
            ecsContext: {
                settings: {
                    useMeetingsApi: false,
                    useUnifiedView: false,
                },
            },
        };
    }
    componentDidUpdate(prevProps) {
        if (prevProps.loading && !this.props.loading) {
            document.title = bew_localization_1.localizer.getString('hdr_launch_title');
        }
        if (this.props && !!this.props.userContext &&
            prevProps && !!prevProps.userContext &&
            prevProps.userContext.isLoginInProgress && !this.props.userContext.isLoginInProgress) {
            this.loadConversation();
        }
    }
    render() {
        if (this.state.error) {
            throw this.state.error;
        }
        const conversation = this.state.meetingContext ? this.state.meetingContext.conversation : undefined;
        const isLoading = this.props.loading || this.state.loadingEcs || this.state.loadingConversation;
        return React.createElement(MeetingContext_1.MeetingContextProvider, { value: this.state.meetingContext },
            React.createElement(EcsContext_1.EcsContextProvider, { value: this.state.ecsContext },
                !!this.state.launcherKey && conversation && React.createElement(Launcher_1.Launcher, { key: this.state.launcherKey, conversation: conversation }),
                React.createElement(AriaContext_1.AriaContextConsumer, null, (ariaContext) => {
                    if (isLoading) {
                        return React.createElement(LoadingView_1.LoadingView, null);
                    }
                    else {
                        return React.createElement(StackNavigationView_1.StackNavigationView, { ariaContext: ariaContext, loading: isLoading, initialView: this.getLoginView(), initialViewProps: { eventViewName: 'join-view' } });
                    }
                })));
    }
    determineIsItUnifiedView(unifiedViewEcsSettings) {
        return (unifiedViewEcsSettings && EnvironmentHelper_1.deviceType === EnvironmentHelper_1.DeviceTypes.Desktop);
    }
    loadConversationFromHuddleApi(shortId) {
        HuddleApiClient_1.default.getConversation({
            shortId,
            type: SharedTypes_1.AppIds.Meetings,
        }).then((conversation) => {
            this.setState({
                loadingConversation: false,
                meetingContext: {
                    conversation,
                    csrfToken: CookieHelper_1.CookieHelper.getCookie(config_1.default.cookies.csrf).singleValue,
                    shortId,
                },
            });
            LoggerHelper_1.logger.initCommonProperty({ key: LoggerHelper_1.CommonProperty.ThreadId, value: conversation.resource, piiKind: webjs_sdk_1.AWTPiiKind.GenericData });
        }).catch((response) => {
            const error = ErrorHelper_1.ErrorHelper.enrichErrorFromWebResponse(ErrorHelper_1.displayableErrors.ShortIdFromUrl, response, 'Get conversation details');
            this.setState({
                error,
            });
        });
    }
    loadConversationFromMeetingsApi(shortId) {
        MeetingsApiClient_1.default.getConversation({
            shortId,
            type: SharedTypes_1.AppIds.Meetings,
        }).then((conversation) => {
            this.setState({
                loadingConversation: false,
                meetingContext: {
                    conversation,
                    csrfToken: CookieHelper_1.CookieHelper.getCookie(config_1.default.cookies.csrf).singleValue,
                    shortId,
                },
            });
            LoggerHelper_1.logger.initCommonProperty({ key: LoggerHelper_1.CommonProperty.ThreadId, value: conversation.resource, piiKind: webjs_sdk_1.AWTPiiKind.GenericData });
        }).catch((response) => {
            const error = ErrorHelper_1.ErrorHelper.enrichErrorFromWebResponse(ErrorHelper_1.displayableErrors.ShortIdFromUrl, response, 'Get conversation details');
            this.setState({
                error,
            });
        });
    }
    _getShortIdFromUrl() {
        const pathName = window.location.pathname.replace(/\/+$/, '');
        const pathParts = pathName.split('/');
        return pathParts.pop();
    }
}
exports.RootView = RootView;
